import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import IdleVue from 'idle-vue'
import setGlobalHelpers from './global.helpers'

import './mixins'
import './plugins'
import './thirdParty'
import i18n from './plugins/i18n'

import './scss/style.scss'
// import './assets/fonts/bebasneue.css'

import VueFilterDateParse from 'vue-filter-date-parse'
import VueFilterDateFormat from 'vue-filter-date-format'
import VueElementLoading from 'vue-element-loading'
import VueAnalytics from 'vue-analytics'

window.$ = window.jQuery = require('jquery')

Vue.use(VueAnalytics, {
  id: 'UA-163432233-1',
  router
})

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3000
})

Vue.component('VueElementLoading', VueElementLoading)
Vue.use(VueFilterDateFormat)
Vue.use(VueFilterDateParse)
Vue.use(require('vue-moment'))

setGlobalHelpers()
Vue.config.productionTip = false

new Vue({
  name: 'Root',
  router,
  i18n,
  store,
  mounted () {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth))
  },
  computed: {
    isIdle () {
      return this.$store.state.idleVue.isIdle
    }
  },
  render: h => h(App)
}).$mount('#app')
